import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { TagButtonWrap } from '../../../../ui';
import { useStores } from '../../../app/root/domain/stores/useStores';
import { AccessTypeFilterButton } from './AccessTypeFilterButton';
import { useAccessTypeSelectHandler } from './helpers/useAccessTypeSelectHandler';
import { useAvailableAccessTypes } from './helpers/useAvailableAccessTypes';

interface IAccessTypeFilterProps {
	disabled?: boolean;
}

export const AccessTypeFilter = observer(
	({ disabled }: IAccessTypeFilterProps) => {
		const { checkpointQueueListStore: store } = useStores();
		const accessTypes = useAvailableAccessTypes();
		const handleSelect = useAccessTypeSelectHandler();

		return (
			<Wrap>
				{accessTypes.map((accessType) => (
					<AccessTypeFilterButton
						key={accessType}
						accessType={accessType}
						onSelect={handleSelect}
						active={accessType === store.accessType}
						disabled={disabled}
					/>
				))}
			</Wrap>
		);
	},
);

const Wrap = styled(TagButtonWrap)`
	margin-bottom: 24px;
`;
